/* ═══════════════════════════════════════════════════════════
   sp-cart-add.js
   Quick-add desde la tarjeta de producto (icono de carrito):
   · POST /cart/add.js → GET /cart.js (fuente de verdad del conteo)
   · Animación "vuelo al carrito": clona la imagen y la lleva al icono del header
   · Bump del contador al aterrizar; crea el badge si el carrito estaba vacío
   · Delegación en document → funciona con tarjetas insertadas por infinite scroll
   · Respeta prefers-reduced-motion
   NO toca la clase CartDrawer existente (postura conservadora).
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var cartToggle = document.querySelector('[data-cart-toggle]');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ───────── vuelo al carrito (arco parabólico + rebote) ─────────
     Dos capas: la externa se mueve en X (lineal) y la interna en Y (con
     aceleración tipo gravedad) → trayectoria en arco. Al aterrizar, el icono
     del carrito rebota. */
  function flyToCart(img, done) {
    if (reduceMotion || !img || !cartToggle) { done(); return; }

    var start = img.getBoundingClientRect();
    var end = cartToggle.getBoundingClientRect();
    if (!start.width || !end.width) { done(); return; }

    var dx = (end.left + end.width / 2) - (start.left + start.width / 2);
    var dy = (end.top + end.height / 2) - (start.top + start.height / 2);

    var outer = document.createElement('div');
    outer.className = 'sp-fly-clone';
    outer.style.cssText =
      'position:fixed;z-index:2000;pointer-events:none;margin:0;' +
      'left:' + start.left + 'px;top:' + start.top + 'px;' +
      'width:' + start.width + 'px;height:' + start.height + 'px;' +
      'transition:transform .8s linear;will-change:transform;';

    var clone = img.cloneNode(true);
    clone.removeAttribute('loading');
    clone.style.cssText =
      'width:100%;height:100%;object-fit:cover;border-radius:12px;' +
      'box-shadow:0 10px 30px rgba(0,0,0,.28);' +
      'transition:transform .8s cubic-bezier(.45,0,.9,.55),opacity .8s ease;will-change:transform,opacity;';
    outer.appendChild(clone);
    document.body.appendChild(outer);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        outer.style.transform = 'translateX(' + dx + 'px)';
        clone.style.transform = 'translateY(' + dy + 'px) scale(.12) rotate(24deg)';
        clone.style.opacity = '.4';
      });
    });

    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      outer.remove();
      cartToggle.classList.remove('sp-cart-pop');
      void cartToggle.offsetWidth;
      cartToggle.classList.add('sp-cart-pop');
      done();
    }
    clone.addEventListener('transitionend', finish, { once: true });
    setTimeout(finish, 900); /* fallback por si no dispara transitionend */
  }

  /* ───────── add to cart ───────── */
  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed: ' + r.status);
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    }).then(function (r) {
      if (!r.ok) throw new Error('cart fetch failed');
      return r.json();
    });
  }

  /* ───────── click (delegado) ───────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var id = btn.getAttribute('data-quick-add');
    if (!id || btn.classList.contains('is-loading')) return;

    btn.classList.add('is-loading');

    var card = btn.closest('[data-product-card]');
    var img = card ? card.querySelector('img') : null;

    addToCart(id)
      .then(function (cart) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-done');
        setTimeout(function () { btn.classList.remove('is-done'); }, 1200);
        if (window.Atelier) {
          if (Atelier.refreshCartDrawer) Atelier.refreshCartDrawer();
          if (Atelier.refreshCartPage) Atelier.refreshCartPage();
        }
        flyToCart(img, function () {
          if (window.Atelier && typeof Atelier.updateCartCount === 'function') {
            Atelier.updateCartCount(cart.item_count);
          }
        });
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        setTimeout(function () { btn.classList.remove('is-error'); }, 1500);
      });
  });

  /* ───────── submit del form de producto (ficha) ─────────
     AJAX + vuelo + contador, igual que las tarjetas. Sin JS, el form envía
     normal a /cart (mejora progresiva). */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();

    var idField = form.querySelector('[name="id"]');
    var qtyField = form.querySelector('[name="quantity"]');
    var id = idField && idField.value;
    if (!id) { form.submit(); return; }

    var qty = qtyField ? (parseInt(qtyField.value, 10) || 1) : 1;
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) { if (submitBtn.disabled) return; submitBtn.disabled = true; }

    var scope = form.closest('.product-page') || document;
    var img = document.getElementById('ProductMainImage') || scope.querySelector('img');

    addToCart(id, qty)
      .then(function (cart) {
        if (submitBtn) submitBtn.disabled = false;
        if (window.Atelier) {
          if (Atelier.refreshCartDrawer) Atelier.refreshCartDrawer();
          if (Atelier.refreshCartPage) Atelier.refreshCartPage();
        }
        flyToCart(img, function () {
          if (window.Atelier && typeof Atelier.updateCartCount === 'function') Atelier.updateCartCount(cart.item_count);
        });
      })
      .catch(function () {
        if (submitBtn) submitBtn.disabled = false;
        form.submit(); /* fallback: envío normal */
      });
  });
})();
